import React, { useState, useEffect } from 'react';
import BackIcon from '../../static/icons/back-icon.png';
import axios from 'axios';

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;

export const ListView = (props) => {
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const days = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const { setRoomIdSelected, setRoomNameSelected, setPage, setListScreen, floorPlanScreenClicked, dateFrom, dateTo,isDesk, isRoom,isOffice } = props;
  const [filteredRooms, setFilteredRooms] = useState();
  const employee = JSON.parse(localStorage.getItem('employee'));
  const [availableRooms, setAvailableRooms] = useState([]);
  const [date, setDate] = useState();

  useEffect(()=> {
    const date = new Date();
    const month = months[date.getMonth()];
    const day = days[date.getDay()];
    const dateNum = date.getDate();
    const year = date.getFullYear();
    const dateString = day + ' ' + dateNum + ' ' + month + ' ' + year;
    setDate(dateString);
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getAvailableRooms = async () => {
    const { data } = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms/availableList`, {
      accountId: employee.accountId,
      dateFrom: new Date(dateFrom).getTime(),
      dateTo: new Date(dateTo).getTime(),
      isDesk: isDesk === undefined ? false: isDesk,
      isRoom: isRoom === undefined ? false: isRoom,
      isOffice: isOffice === undefined ? false: isOffice,
    });
    const availableRooms = data.rooms.filter((room)=> room.isBlocked === undefined || room.isBlocked === false)
    setAvailableRooms(availableRooms);
    setFilteredRooms(availableRooms);
  };

  useEffect(() => {
    getAvailableRooms();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleInputChange = (event) => {
    const query = event.target.value;

    setFilteredRooms(() => {
      if (query) {
        const filteredData = availableRooms.filter((element) => {
          return element.name.toLowerCase().includes(query.toLowerCase());
        });
        return filteredData;
      } else {
        return availableRooms;
      }
    });
  };
  return (
    <div className="w-full grid grid-cols-1">
      <div className="static flex flex-row">
        <img
          onClick={() => {
            setListScreen(false);
            setPage(1);
          }}
          className="w-3 h-4"
          src={BackIcon}
          alt="back"
        />
        <span
          onClick={() => {
            setListScreen(false);
            setPage(1);
          }}
          className="text-blue-300 text-center font-semibold text-xs ml-2"
        >
          Back
        </span>
        <span className="text-center text-center font-semibold text-xs ml-8" style={{ color: '#565656' }}>
          Search results
        </span>
      </div>
      <div className="flex flex-row justify-between mt-4">
        <p className="text-center text-center font-semibold text-xs" style={{ color: '#565656' }} onClick={floorPlanScreenClicked}>
          Floor Plan View
        </p>
        <p className="text-center font-semibold text-xs underline" style={{ color: '#51D1FA' }}>
          List View
        </p>
      </div>
      <div className="relative text-gray-600 bg-gray-600 focus-within:text-gray-400 border-2 border-slate-500 rounded-md mt-2">
        <span className="absolute inset-y-0 left-0 flex items-center pl-2">
          <button type="button" className="p-1 focus:outline-none focus:shadow-outline">
            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="w-6 h-6">
              <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </button>
        </span>
        <input
          type="search"
          name="q"
          className="w-full py-2 text-sm text-black bg-white rounded-md pl-10 border-slate-300 focus:outline-none focus:border-blue-300"
          placeholder="Search"
          onChange={handleInputChange}
          autoComplete="off"
        />
      </div>
      <div className="text-xs mt-2" style={{ color: '#959494' }}>
        <span className="font-bold" style={{ color: '#565656' }}>
          Today
        </span>{' '}
        {date}
      </div>
      <div>
        {filteredRooms ? (
          filteredRooms.length > 0 ? (
            filteredRooms.map((mr, index) => {
              return (
                <div
                  className="w-full grid grid-rows-1 bg-white columns-1 my-6 border-2 border-gray-200"
                  style={{ height: '158px', borderRadius: '20px' }}
                  key={index}
                >
                  <div className="grid grid-cols-2 my-2.5">
                    <div className='ml-4 my-4'>
                      <img style={{width: '105px', height: '98px'}} src={`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/rooms/getAvatar/` + mr.id + `?small=true`} alt={'room'} />
                    </div>
                    <div className='w-full pr-4 my-auto'>
                      <div className="grid grid-rows-1 text-left text-base font-semibold text-gray-700">{mr.name}</div>
                      <div className="grid grid-rows-1 text-left text-xs font-normal text-gray-700">{mr.location}</div>
                      <div className="grid grid-rows-1 text-left text-xs font-normal text-gray-700">Capacity: {mr.capacity}</div>
                      <div className="grid grid-rows-1 text-left text-xs font-normal text-gray-700">AV: {mr.description}</div>
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      setRoomIdSelected(mr.id);
                      setRoomNameSelected(mr.name);
                      setListScreen(false);
                      setPage(2);
                    }}
                    className="h-8 text-center text-white border-2 border-gray-100 mt-32"
                    style={{width: '320px', position: 'relative', bottom: '4px', left: '-2px', backgroundColor: '#51D1FA', borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}
                  >
                    Book Now
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center text-black mt-20">No {isRoom ? 'Rooms' : isOffice ? 'Office' : 'Desks'} available</div>
          )
        ) : (
          <div className="text-center text-black mt-20">Fetching Data</div>
        )}
      </div>
    </div>
  );
};
